import { render, staticRenderFns } from "./storeCell.vue?vue&type=template&id=71db8cfb&scoped=true"
import script from "./storeCell.vue?vue&type=script&lang=js"
export * from "./storeCell.vue?vue&type=script&lang=js"
import style0 from "./storeCell.vue?vue&type=style&index=0&id=71db8cfb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71db8cfb",
  null
  
)

export default component.exports